import { createContext, PropsWithChildren, useContext } from 'react';
import { useAuthenticationProvider } from 'infrastructure/security/authentication/AuthenticationProvider';
import { InterruptionsContextValue } from './types';
import useInterruptionsController from './hooks/interruptionsController/useInterruptionsController';
export { initialInterruptionsState } from './reducer';

type InterruptionsProviderProps = PropsWithChildren<{
  isAvailabilityEnabled: boolean;
}>;

const InterruptionsContext = createContext<InterruptionsContextValue | null>(null);

export const useInterruptionsContext = () => {
  const context = useContext(InterruptionsContext);

  if (!context) {
    throw new Error('useInterruptionsContext must be used within InterruptionsProvider');
  }

  return context;
};

export const InterruptionsProvider = ({ children, isAvailabilityEnabled }: InterruptionsProviderProps) => {
  const { getUserAlias, isAuthenticated } = useAuthenticationProvider();
  const contextValue = useInterruptionsController({
    isAvailabilityEnabled,
    isAuthenticated,
    userId: getUserAlias() || '',
  });

  return <InterruptionsContext.Provider value={contextValue}>{children}</InterruptionsContext.Provider>;
};
